module.exports = __webpack_public_path__ + "img/fb-f.36d326b3.svg";